export default "__VITE_ASSET__K0YY4sXm__"